// import PropTypes from 'prop-types'
import { DialogContent } from '@mui/material'
// import FormikSelect from '../../../molecules/FormikSelect'
import axios from 'axios'
import { useEffect, useState } from 'react'
import NotesPreview from './NotesPreview'

const PatientNoteFactory = ({ ...values }) => {
  const [content, setContent] = useState('')

  const id = values.id
  const patientId = values.patient_id

  useEffect(() => {
    fetchNote()
  }, [])

  const fetchNote = (values) => {
    axios.get(`/patients/${patientId}/notes/${id}`, values).then((response) => {
      setContent(response.data.content)
    })
  }

  return (
    <>
      <DialogContent dividers={true}>
        <NotesPreview comment={content} />
      </DialogContent>
    </>
  )
}

// PatientNoteFactory.propTypes = {
//   PatientNoteFactoryProp: PropTypes.string,
// }

export default PatientNoteFactory
